import { MapPin, Phone, MessageCircle, Clock } from "lucide-react";
import { waLink, WHATSAPP_NUMBER } from "../lib/data";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#06070A] border-t border-white/5 pt-20 pb-10"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 pb-16 border-b border-white/5">
          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <span className="flex items-center justify-center w-10 h-10 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/5">
                <span className="font-display text-[#D4AF37] italic text-lg leading-none">P</span>
              </span>
              <div className="font-display text-white text-xl tracking-tight">
                Polarizados <span className="italic text-[#D4AF37]">Querétaro</span>
              </div>
            </div>
            <p className="text-sm text-white/50 font-light leading-relaxed max-w-sm">
              Especialistas en película de polarizado para hogares, oficinas,
              edificios, comercios y plantas industriales en Querétaro.
              Materiales certificados 3M, Solex y Llumar.
            </p>
            <div className="mt-6 flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-white/35">
              <span>3M</span>
              <span className="w-1 h-1 rounded-full bg-[#D4AF37]" />
              <span>Solex</span>
              <span className="w-1 h-1 rounded-full bg-[#D4AF37]" />
              <span>Llumar</span>
            </div>
          </div>

          {/* Servicios */}
          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5">
              Servicios
            </div>
            <ul className="space-y-3 text-sm text-white/65">
              <li><a href="#servicios" data-testid="footer-link-industrial" className="hover:text-white">Industrial</a></li>
              <li><a href="#servicios" data-testid="footer-link-oficinas" className="hover:text-white">Edificios y Oficinas</a></li>
              <li><a href="#servicios" data-testid="footer-link-residencial" className="hover:text-white">Residencial</a></li>
              <li><a href="#servicios" data-testid="footer-link-comercios" className="hover:text-white">Comercios y Locales</a></li>
              <li><a href="#tipos" data-testid="footer-link-seguridad" className="hover:text-white">Película de Seguridad</a></li>
              <li><a href="#tipos" data-testid="footer-link-inteligente" className="hover:text-white">Película Inteligente</a></li>
            </ul>
          </div>

          {/* Contacto */}
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5">
              Contacto
            </div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/75">
                <MapPin size={16} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <span>
                  Querétaro, Qro.
                  <br />
                  <span className="text-white/45 text-xs">
                    Centro · Corregidora · El Marqués · San Juan del Río
                  </span>
                </span>
              </li>
              <li>
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="inline-flex items-start gap-3 text-white/75 hover:text-[#D4AF37]"
                >
                  <MessageCircle size={16} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
                  <span>
                    WhatsApp: {WHATSAPP_NUMBER}
                    <br />
                    <span className="text-white/45 text-xs">Respuesta en menos de 1 hora</span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  href="tel:+5214423429535"
                  data-testid="footer-call-link"
                  className="inline-flex items-start gap-3 text-white/75 hover:text-[#D4AF37]"
                >
                  <Phone size={16} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
                  <span>+52 1 442 342 9535</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/75">
                <Clock size={16} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <span>
                  Lunes a Sábado · 9:00 a 19:00 hrs
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/35">
          <div>© {new Date().getFullYear()} Polarizados Querétaro · PPQ. Todos los derechos reservados.</div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] animate-pulse" />
            Cobertura activa en Querétaro
          </div>
        </div>
      </div>
    </footer>
  );
}
